import setUtil from 'utils/set'
import { REDUX_STATUS } from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

function saveReduxReducer (state, action) {
  const {
    path
  } = action.payload
  return setUtil(state, path, {
    ...getObjectUtil(state, path),
    error: null,
    validation: null,
    status: REDUX_STATUS.SAVING
  })
}

export default saveReduxReducer
